<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="用户原密码" prop="oldPassword" >
                <el-input v-model="formData.oldPassword"  type="password"></el-input>
            </el-form-item>

            <el-form-item label="用户新密码" prop="newPassword" >
                <el-input v-model="formData.newPassword"  show-password></el-input>
            </el-form-item>

            <el-form-item label="重复新密码" prop="confirmNewPassword">
                <el-input v-model="formData.confirmNewPassword"  show-password></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    export default {
        name: "RoleAdd",
        components: {},
        data() {
            return {
                api:{
                    updateUserPassword:this.$api.auth.updateUserPassword
                },
                formErrorMsg:{
                    oldPassword: '',
                    newPassword: '',
                    confirmNewPassword: ''
                },
                formData: {
                    oldPassword: '',
                    newPassword: '',
                    confirmNewPassword: ''
                },
                rules: {
                    oldPassword: [
                        {required: true, message: '请输入原密码', trigger: 'blur'},
                    ],
                    newPassword: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                    ],
                    confirmNewPassword: [
                        {required: true, message: '请重复输入新密码', trigger: 'blur'},
                        {validator:(rule, value, callback)=>{
                                     if(value !== this.formData.newPassword){
                                         callback(new Error("两次输入密码不一致"))
                                     }else{
                                         callback();
                                     }
                            }, trigger: 'change'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {

                    if (valid) {
                        vm.$http.post(vm.api.updateUserPassword,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                let userInfo = JSON.parse(sessionStorage.getItem("login-user-info"));
                                userInfo.lastUpdatePwdTime = resp.data.time;
                                sessionStorage.setItem("login-user-info",JSON.stringify(userInfo));

                                vm.$router.push('/login');
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>